import 'vue-demi';

import { PiniaVuePlugin } from 'pinia';
import Vue from 'vue';

import VueCompositionAPI from '@vue/composition-api';

import LayoutDrawerRoot from './layouts/DrawerRoot.vue';

Vue.use(VueCompositionAPI);
Vue.use(PiniaVuePlugin);

export {
  LayoutDrawerRoot
};
